<ng-container *ngIf="selectDialog$ | async"></ng-container>
<ng-container *ngIf="material$ | async"></ng-container>
<ng-container *ngIf="data$ | async"></ng-container>

<csl-item-card
  [disabled]="disabled"
  (selectClicked)="openSelectDialog()"
  [description]="getDescription()"
  [iconLink]="getIconLink()"
  i18n-title
  title="Тип столешницы">
</csl-item-card>
